import type { ConferenceState } from '../convex/useConference';

export type PermissionKey = keyof ConferenceState['conference']['permissions'];

export const permissionLabels: Record<PermissionKey, string> = {
  audio: 'Audio',
  chat: 'Chat',
  navigate: 'Room Switching',
  rooms: 'Rooms',
  screenshare: 'Screenshare',
  topMenuControl: 'WB Navigation',
  video: 'Video',
  whiteboard: 'Whiteboard',
};

export function getPermissionLabel(permission: PermissionKey): string {
  return permissionLabels[permission];
}
